import ApiClient from './ApiClient'

export default class DashboardClient extends ApiClient {
    countMessages = () => this.get('/dashboard/messages')
    messagesRange = args => this.get('/dashboard/messages_range', args)

    countUsers = () => this.get('/dashboard/users')
    usersRange = args => this.get('/dashboard/users_range', args)

    countConnections = () => this.get('/dashboard/connections')
    connectionsRange = args => this.get('/dashboard/connections_range', args)
}
